.root {
  align-self: stretch;
  margin: 2px 2px;
}

.head {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 7px 11px;
  border: 1px solid var(--line-2);
  border-radius: 10px;
  background: color-mix(in oklch, var(--sunk) 55%, var(--panel));
  color: var(--ink-2);
  font: inherit;
  font-size: 12px;
  text-align: left;
}

button.head {
  cursor: pointer;
}

button.head:hover {
  background: var(--sunk);
}

.dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--tint);
}

.text {
  flex: 1;
  min-width: 0;
}

.time {
  flex-shrink: 0;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  color: var(--ink-4);
}

.chevron {
  flex-shrink: 0;
  color: var(--ink-3);
  transition: transform 0.16s ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.detail {
  margin: 6px 0 0;
  padding: 9px 12px;
  border: 1px solid var(--line-2);
  border-radius: 8px;
  background: var(--panel);
  color: var(--ink-2);
  font-size: 12px;
  line-height: 1.5;
}
